import { render, staticRenderFns } from "./OrderableNote.vue?vue&type=template&id=4c137441&"
import script from "./OrderableNote.vue?vue&type=script&lang=ts&"
export * from "./OrderableNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports